module.exports = __webpack_public_path__ + "static/media/tags-popover-demonstration.e3c00467.svg";